import classNames from "classnames";
import React, { ReactNode } from "react";

interface ContentWrapperProps {
  children: ReactNode;
  fullWidth?: boolean;
  className?: string;
}

export const ContentWrapper: React.FC<ContentWrapperProps> = ({
  children,
  fullWidth = false,
  className = "",
}) => {
  return (
    <div
      className={classNames(!fullWidth && `max-w-page mx-auto px-4`, className)}
    >
      {children}
    </div>
  );
};

export default ContentWrapper;
